import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ActionModal } from 'components/mui/common/ActionModal';
import type { DocumentEditorConfirmationProps } from 'types/documentEditing';

export const DocumentEditorConfirmation = ({ open, onConfirm, onCancel }: DocumentEditorConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <ActionModal
      open={open}
      onSubmit={onConfirm}
      onClose={onCancel}
      onCancel={onCancel}
      title={t('user.documentEditor.confirmTitle')}
      submitText={t('common.confirm')}
      cancelText={t('common.cancel')}>
      <Typography>{t('user.documentEditor.confirmLeave')}</Typography>
    </ActionModal>
  );
};
